import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './MediaError.scss';

const MediaError = () => {
  const { t } = useTranslation();

  return (
    <div className="media-error">
      <div className="svg-icon svg-icon--error-plain"></div>
      <div>{t('mediaError.error')}</div>
    </div>
  );
};

MediaError.propTypes = {
  type: PropTypes.string,
};

export default MediaError;
